<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="用户名" prop="username">
        <el-input v-model="search.username" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="用户姓名" prop="fullname">
        <el-input v-model="search.fullname" placeholder="请输入用户姓名"></el-input>
      </el-form-item>
      <el-form-item label="所属组织" prop="partnershipId">
        <BelongOrgSelect ref="belongOrgSelectRef" v-model="search.partnershipId"></BelongOrgSelect>
      </el-form-item>
      <el-form-item label="角色" prop="role">
        <el-select clearable v-model="search.role" placeholder="请选择角色">
          <el-option v-for="item in roleListOptions" :label="item.roleName" :key="item.id" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="getList()">查询</el-button>
      <el-button size="medium" @click="resetForm('search')">重置</el-button>
      <!-- <el-button type="primary" size="medium" @click="$router.push({path:'/system/adminAdd'})">+&nbsp;创建管理员</el-button> -->
      <el-button type="primary" size="medium" @click="addAdminFun">+&nbsp;创建管理员</el-button>
    </div>

    <el-table ref="checktableData" :data="list" v-loading="listLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="用户编号" type="index" width="80"></el-table-column>
      <el-table-column label="用户名" prop="username" width="120"></el-table-column>
      <el-table-column label="用户姓名" prop="fullname" width="120"></el-table-column>
      <el-table-column label="所属组织" prop="partnerName" width="120"></el-table-column>
      <el-table-column label="身份角色" min-width="100" align="center">
        <template slot-scope="scope">{{ formatRole(scope.row.role) }}</template>
      </el-table-column>

      <el-table-column label="联系方式" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.phone }}</template>
      </el-table-column>
      <el-table-column label="员工编号" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.account }}</template>
      </el-table-column>
      <el-table-column label="认证状态" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.authStatus == 0 ? '未认证' : '已认证' }}</template>
      </el-table-column>
      <el-table-column label="员工状态" min-width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.employed === 0">离职</span>
          <span v-else-if="scope.row.employed === 1">在职</span>
        </template>
      </el-table-column>
      <el-table-column label="是否有效" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.flag == 0 ? '无效' : '有效' }}</template>
      </el-table-column>
      <el-table-column label="邮箱号" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.email }}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goEdit(scope.row.id)">编辑</el-button>
          <el-button type="text" @click="delectUser(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.pageNum"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <AddAdminDialog ref="addAdminDialogRef"></AddAdminDialog>
  </div>
</template>

<script>
import BelongOrgSelect from '@/components/BelongOrgSelect'
import AddAdminDialog from './components/AddAdminDialog'
export default {
  name: 'home',
  components: {
    BelongOrgSelect,
    AddAdminDialog
  },
  data() {
    return {
      list: [],
      search: {
        fullname: '', //用户编号
        username: '', //注册手机号
        partnershipId: '', //合作方名称
        role: '',
        pageSize: 10,
        pageNum: 1
      },
      isEdit: false,
      listLoading: false,
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [], // 所有未选中的id
      oldarr: [],
      arr: [],
      total: 20,
      roleOptions: [
        { label: '普通管理员', value: 0 },
        { label: '超级管理员', value: 1 },
        { label: '分公司', value: 3 },
        { label: '合作方', value: 4 }
      ],
      // 角色下拉选择
      roleListOptions: []
    }
  },
  filters: {},
  created() {
    this.getList()
    this.getRoleList()
  },
  methods: {
    getList() {
      this.HttpService.post('/autoapp-recovery-server-auth/api/recoveryManage/selectManage', this.search).then(res => {
        if (res.statusCode === 200) this.total = res.total
        this.arr = res.data
        this.list = this.arr.slice(0, this.search.pageSize)
      })
    },
    handleSizeChange(val) {
      this.search.pageNum = 1
      this.search.pageSize = val
      this.getList()
    },
    handleCurrentChange() {
      // this.oldarr = this.oldarr.concat(this.unSelectedIds)
      // this.unSelectedIds = [...new Set(this.oldarr)]
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    delectUser(id) {
      this.$dialog({
        title: '温馨提示',
        content: '是否要删除此账户，删除后不可以恢复！',
        cancel_buttton: '否',
        ok_buttton: '是',
        footBtn: false,
        width: '400px',
        footBtn: 'card',
        dialogType: 'delete',
        onOk: () => {
          console.log('ok')
          if (id)
            this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryManage/delManage/${id}`).then(res => {
              if (res.statusCode === 200) {
                this.$message.success('删除成功')
              }
              this.getList()
            })
        },
        onCancel: () => {
          console.log('cancel')
        }
      })
    },
    goEdit(id) {
      this.$router.push({
        path: '/user/userEdit',
        query: {
          id: id,
          type: 'system'
        }
      })
    },
    formatRole(value) {
      const obj = this.roleListOptions.find(item => item.id == value)
      return obj ? obj.roleName : ''
    },
    // 创建管理员
    addAdminFun() {
      this.$refs.addAdminDialogRef.openDialog()
    },
    // 获取角色列表
    getRoleList() {
      const url = `/autoapp-recovery-server-auth/api/tbl-role/listChildrenRoleIds`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.roleListOptions = res.data || []
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}

.row-bg {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/adminGet.vue